const translations = {
  'graduates.seo.title': 'Reseñas de cursos y testimonios de graduados',
  'graduates.seo.description':
    'Lee reseñas y testimonios de estudiantes y egresados de TEFL Iberia, y solicita más información para convertirte en estudiante.',
  'graduates.sec1.title': 'Los Graduados de TEFL Iberia ',
  'graduates.sec1.description':
    ' En TEFL Iberia nos encanta crear experiencias memorables. Nos enorgullecemos de proporcionar una formación de alta calidad, un sistema de apoyo esencial y, lo más importante, una oportunidad de cambio de vida para trabajar en el extranjero. Escucha de primera mano lo que dicen nuestros graduados:',
  'graduates.sec1.benTitle': 'En los videos, los graduados destacan:',
  'graduates.sec1.ben1': 'Sentirse seguros para estar frente a una clase y enseñar',
  'graduates.sec1.ben2': 'Enseñar a estudiantes reales',
  'graduates.sec1.ben3': 'Encontrar un trabajo rápidamente después del curso',
  'graduates.sec2.modalTitle':
    'Síguenos en las redes sociales y mantente al día con todas las increíbles actividades que disfrutan nuestros estudiantes. ',
  'graduates.sec2.modalDescription': 'Mantente al día con nuestros estudiantes en Instagram',
};

export default translations;
